
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Qu’en est-il en Suisse?`}</em></p>
    <p>{`Après une demande adressée à la Suisse en décembre dernier,
`}<a parentName="p" {...{
        "href": "https://www.swissmedic.ch/swissmedic/fr/home/news/coronavirus-covid-19/dritten-impfstoff-gegen-covid-19-erkrankung.html"
      }}>{`Swissmedic a autorisé ce vaccin`}</a>{`
le 22 mars. Ce produit est ainsi le troisième à pouvoir être commercialisé dans
notre pays.`}</p>
    <p>{`Le 29 septembre, l'Office fédéral de la santé publique (OFSP) a annoncé que
150'000 doses avaient été achetées et seraient distribuées la semaine suivante
aux cantons.`}</p>
    <p>{`Ces doses sont destinées aux personnes dès 18 ans qui ne peuvent pas ou ne
veulent pas être vaccinées avec un vaccin à ARN messager. De façon générale, la
`}<a parentName="p" {...{
        "href": "https://www.infovac.ch/docs/public/coronavirus/bag/covid-19-recommandation-pour-vaccin-janssen-e--tat-29-09-21.pdf"
      }}>{`Confédération conseille toutefois de recourir en premier lieu aux vaccins à ARNm`}</a>{`,
dès l’âge de 12 ans.C'est particulièrement vrai pour les personnes
immunodéficientes et les femmes enceintes.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;